var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"my-1"},[_c(_setup.list,{attrs:{"data":_setup.productAreas,"config":_setup.listConfig}}),_c(_setup.AddProductAreaModal,{attrs:{"show-modal":_setup.showModal,"product-area":_setup.selectedProductArea,"catalog-id":_setup.props.catalogId},on:{"close":_setup.onCloseModal,"submit":_setup.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }